import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEmployeesComponent } from './add-employees/add-employees.component';
import { SharedModule } from '../shared/shared.module';
import { EmployeesListComponent } from './employees-list/employees-list.component';
import { EmployeesRoutingModule } from './employees-routing.module';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeAddStatusComponent } from './employee-add-status/employee-add-status.component';
import { FormsModule } from '@angular/forms';
import { BulkUploadEmployeesComponent } from './bulk-upload-employees/bulk-upload-employees.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DataService } from '../services/data.service';
import { Ng2SearchFilterModule } from '../_Shared/ng2-search-filter.module';

@NgModule({
  declarations: [AddEmployeesComponent, EmployeesListComponent, EmployeeDetailsComponent, EmployeeAddStatusComponent, BulkUploadEmployeesComponent],
  imports: [
    CommonModule,
    SharedModule,
    EmployeesRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    Ng2SearchFilterModule

  ],
  providers: [DataService]
})
export class EmployeesModule { }
